import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';

export interface NumeroMiaGestor {
  id: number;
  nome: string;
  telefone: string;
  whatsappId: string;
  status: string;
  empresa: {id: number; nome: string} | null;
  miaGestor: boolean;
  sdrContatos: string;
}

/**
 * Qual número Cloud é a Mia Gestor e quem pode conversar com ela.
 * Só o superadmin salva; o servidor garante um único número com o papel.
 */
@Component({
  selector: 'app-numeros-mia-gestor',
  templateUrl: './numeros-mia-gestor.component.html',
  styleUrls: ['./numeros-mia-gestor.component.scss'],
})
export class NumerosMiaGestorComponent implements OnInit {
  numeros: NumeroMiaGestor[] = [];
  fallbackAmbiente: string | null = null;
  escolhidoId: number | null = null;
  /** 'todos' | 'lista' */
  quemConversa = 'todos';
  lista = '';
  carregando = false;
  salvando = false;
  erro = '';
  aviso = '';
  filtro = '';

  constructor(private http: HttpClient) {}

  ngOnInit() { this.carregue(); }

  get filtrados() {
    const termo = this.filtro.trim().toLocaleLowerCase();
    if (!termo) return this.numeros;
    return this.numeros.filter(n =>
      `${n.nome} ${n.telefone} ${n.whatsappId} ${n.empresa?.nome || ''}`.toLocaleLowerCase().includes(termo));
  }

  get atual(): NumeroMiaGestor | null {
    return this.numeros.find(n => n.miaGestor) || null;
  }

  get escolhido(): NumeroMiaGestor | null {
    return this.numeros.find(n => n.id === this.escolhidoId) || null;
  }

  get mudou() {
    const atual = this.atual;
    if ((atual?.id || null) !== this.escolhidoId) return true;
    if (!atual) return false;
    return this.contatosDoFormulario() !== (atual.sdrContatos || '');
  }

  async carregue() {
    this.carregando = true; this.erro = '';
    try {
      const r: any = await this.http.get('/gestor-ia/numeros').toPromise();
      this.numeros = r.numeros || [];
      this.fallbackAmbiente = r.fallbackAmbiente || null;
      const atual = this.atual;
      this.escolhidoId = atual ? atual.id : null;
      this.quemConversa = atual && atual.sdrContatos !== '*' && atual.sdrContatos ? 'lista' : 'todos';
      this.lista = atual && atual.sdrContatos && atual.sdrContatos !== '*' ? atual.sdrContatos.split(',').join('\n') : '';
    } catch (e: any) {
      this.erro = e?.error?.erro || 'Não foi possível carregar os números.';
    } finally { this.carregando = false; }
  }

  escolha(n: NumeroMiaGestor) {
    if (this.salvando) return;
    this.escolhidoId = n.id;
    this.aviso = '';
  }

  private contatosDoFormulario(): string {
    if (this.quemConversa === 'todos') return '*';
    return this.lista.split(/[,\n;]/).map(v => v.replace(/\D/g, '')).filter(Boolean).join(',');
  }

  async salve() {
    if (!this.escolhidoId || this.salvando) return;
    this.salvando = true; this.erro = ''; this.aviso = '';
    try {
      await this.http.put(`/gestor-ia/numeros/${this.escolhidoId}`,
        {miaGestor: true, sdrContatos: this.contatosDoFormulario()}).toPromise();
      await this.carregue();
      this.aviso = 'Número da Mia Gestor salvo. Vale para as próximas mensagens, sem reiniciar nada.';
    } catch (e: any) {
      this.erro = e?.error?.erro || 'Não foi possível salvar.';
    } finally { this.salvando = false; }
  }

  async desligue() {
    const atual = this.atual;
    if (!atual || this.salvando) return;
    this.salvando = true; this.erro = ''; this.aviso = '';
    try {
      await this.http.put(`/gestor-ia/numeros/${atual.id}`, {miaGestor: false}).toPromise();
      await this.carregue();
      this.aviso = 'Nenhum número é a Mia Gestor agora. Ele volta a atender como número de loja.';
    } catch (e: any) {
      this.erro = e?.error?.erro || 'Não foi possível desligar.';
    } finally { this.salvando = false; }
  }
}
